import { useQuery } from "@tanstack/react-query";
import { NotificationCenterKeys } from "web_myplann/Api/NotificationCenter/notificationCenterKeys";
import { useDocumentsFeatureOptional } from "web_myplann/Api/Rights/RightsProvider";
import {
	getNotificationCenterRecentV2,
	type TimelineItemCategoryEnum,
	type TimelineResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";
import { filterTimelineItemsByRights } from "web_myplann/NotificationCenter/Utils/filterTimelineItemsByRights";

const STALE_TIME_MS = 60_000;

interface RecentTimelinePreviewParams {
	categories: TimelineItemCategoryEnum[];
	dateFrom: string;
	dateTo: string;
	limit: number;
}

export const useRecentTimelinePreviewQuery = (
	params: RecentTimelinePreviewParams,
) => {
	const hasDocumentsFeature = useDocumentsFeatureOptional();

	return useQuery({
		queryKey: NotificationCenterKeys.recentPreview(
			params.categories,
			params.dateFrom,
			params.dateTo,
			params.limit,
		),
		queryFn: processResponseQuery(() =>
			getNotificationCenterRecentV2(
				undefined,
				params.categories,
				undefined,
				params.dateFrom,
				params.dateTo,
				params.limit,
			),
		),
		staleTime: STALE_TIME_MS,
		select: (data: TimelineResponseDTO) =>
			filterTimelineItemsByRights(data, {
				hasRemindersRight: true,
				hasDocumentsFeature,
			}),
	});
};
